import React__default, { useMemo } from 'react';
import FieldForm from 'rc-field-form';
export { List } from 'rc-field-form';
import { FormContext } from './FormContext.es.js';
import useForm from './useForm.es.js';
export { default as useForm } from './useForm.es.js';
import { SizeContextProvider } from '../../contexts/SizeContext.es.js';
import styled from '@emotion/styled';
import { mergeCls } from '../../helpers/utils.es.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const InternalForm = (props, ref) => {
  const _a = props, {
    className = "",
    form,
    colon,
    labelAlign,
    labelCol,
    wrapperCol,
    layout = "horizontal",
    requiredMark,
    name,
    size = "m"
  } = _a, restFormProps = __objRest(_a, [
    "className",
    "form",
    "colon",
    "labelAlign",
    "labelCol",
    "wrapperCol",
    "layout",
    "requiredMark",
    "name",
    "size"
  ]);
  const mergedRequiredMark = useMemo(() => {
    if (requiredMark !== void 0) {
      return requiredMark;
    }
    return true;
  }, [requiredMark]);
  const [wrapForm] = useForm(form);
  const { __INTERNAL__ } = wrapForm;
  __INTERNAL__.name = name;
  const formContextValue = useMemo(() => ({
    name,
    labelAlign,
    labelCol,
    wrapperCol,
    vertical: layout === "vertical",
    colon,
    requiredMark: mergedRequiredMark,
    itemRef: __INTERNAL__.itemRef
  }), [name, labelAlign, labelCol, wrapperCol, layout, colon, mergedRequiredMark]);
  React__default.useImperativeHandle(ref, () => wrapForm);
  return /* @__PURE__ */ React__default.createElement(SizeContextProvider, {
    size
  }, /* @__PURE__ */ React__default.createElement(FormContext.Provider, {
    value: formContextValue
  }, /* @__PURE__ */ React__default.createElement(StyledFieldForm, __spreadProps(__spreadValues({
    id: name
  }, restFormProps), {
    name,
    form: wrapForm,
    className: mergeCls(className, `teko-form-${layout}`)
  }))));
};
const StyledFieldForm = styled(FieldForm)`
  &.teko-form-vertical {
    .teko-form-item {
      flex-direction: column;
      .teko-form-item-label {
        text-align: left;
      }
    }
  }
  &.teko-form-horizontal {
    .teko-form-item-control {
      flex: 1 1 0;
    }
  }
`;
const Form = React__default.forwardRef(InternalForm);
var InternalForm$1 = Form;

export { InternalForm$1 as default };
